document.addEventListener('DOMContentLoaded', () => {
    const contactForm = document.getElementById('contact-form');
    if (!contactForm) {
        return;
    }
    const inputs = contactForm.querySelectorAll('[required]');
    inputs.forEach(el => {
        el.addEventListener('change', e => {
            el.changed = true;
        });
    })
    contactForm.addEventListener('submit', e => {
        const ok = Array.from(inputs).every(el => el.changed);
        if (!ok) {
            e.preventDefault();
            return false;
        }
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'inquiry[validated_at]');
        input.setAttribute('value', Date.now().toString());
        contactForm.appendChild(input);
        return true;
    });
});